import { Injectable } from "@angular/core";
import { TheNaviGator } from "./the-navi-gator.service";


/**
 * Services that stores stuff in Session Storage, with easy USUABLE functions
 * Session lives untill you CLOSE tab/browser
 */
@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private _returnUrl: string = "";

  /** Set the given RequestGuid as return url for the VIEWER-Download */
  set setDownloadReturnUrlForRequest(requestGuid: string) {
    this.returnUrl = this.theNaviGator.Download_Url(requestGuid);
  }
  /** Set the given RequestGuid as return url for the VIEWER */
  set setViewerReturnUrlForRequest(requestGuid: string) {
    this.returnUrl = this.theNaviGator.Viewer_Url(requestGuid);
  }
  set returnUrl(newValue: string) {
    sessionStorage.setItem("returnUrl", newValue);
    this._returnUrl = newValue;
  }
  /** Stored ReturnUrl */
  get returnUrl(): string {
    return this._returnUrl;
  }
  /** Is the Stored ReturnUrl of the Viewer */
  get storedViewerReturnUrl(): boolean {
    return this.theNaviGator.Is_Viewer_Url(this._returnUrl);
  }

  private _organisationGuid: string = "";
  set organisationGuid(newValue: string) {
    sessionStorage.setItem("organisationGuid", newValue);
    this._organisationGuid = newValue;
  }
  /** Stored OrganisationGuid of the user */
  get organisationGuid(): string {
    return this._organisationGuid;
  }

  private _authority: string = "";
  set authority(newValue: string) {
    sessionStorage.setItem("authority", newValue);
    this._authority = newValue;
  }
  get authority(): string {
    return this._authority;
  }

  set authNonce(newValue: string) {
    sessionStorage.setItem("authNonce", newValue);
  }

  set authStateControl(newValue: string) {
    sessionStorage.setItem("authStateControl", newValue);
  }



  private _filter: string | null = null;
  set filter(newValue: string) {
    sessionStorage.setItem("Filter", newValue);
    this._filter = newValue;
  }
  get filter(): string | null {
    return this._filter;
  }



  /**
   * SET value for whether all request of the organisation should be shown instead of only "Normal" request
   * (available for the organisation admin) 
   */
  public set showAllRequestForOrganisation(show: boolean) {
    this._showAllRequestForOrganisation = show;
    sessionStorage.setItem("ShowAllDocsInOrg", this._showAllRequestForOrganisation.toString());
  }
  /**
   * Stored value for whether all request of the organisation should be shown instead of only "Normal" request
   * (available for the organisation admin) 
   */
  public get showAllRequestForOrganisation(): boolean {
    return this._showAllRequestForOrganisation;
  }


  /** Set the name of the column you are Sorting By */
  public get sortingColumnName(): string {
    return this._sortingColumnName;
  };
  /** Holds the name of the column you are Sorting By */
  public set sortingColumnName(value: string) {
    this._sortingColumnName = value;
    sessionStorage.setItem("SortingColumn", this.sortingColumnName);
  };

  /** Set whether you are sorting by Descending (true)  or Ascending (false) */
  public set sortDescending(descendingDirection: boolean) {
    this._sortDescending = descendingDirection;
    sessionStorage.setItem("SortingDirection", this.sortingDirection);
  }
  /** Get the Sorting Direction as String (desc / asc) */
  public get sortingDirection(): string {
    if (this._sortDescending) {
      return this.descendingDirection;
    }
    return this.ascendingDirection;
  }

  private descendingDirection: string = "desc"
  private ascendingDirection: string = "asc"
  private _sortDescending: boolean = false;
  private _sortingColumnName: string = "";
  private _showAllRequestForOrganisation: boolean = false;

  constructor(private theNaviGator: TheNaviGator) {
    this.LoadFromStorage();
  }
  /**
   * Clears storage and reloads service
   */
  Clear() {
    // clear storage
    sessionStorage.clear();
    // reset variables
    this.LoadFromStorage();
  }

  private LoadFromStorage() {

    // get return url:
    let existingReturnUrl = sessionStorage.getItem("returnUrl");
    if (existingReturnUrl) {
      this._returnUrl = existingReturnUrl!;
    }

    // get organisationGuid:
    let existingOrganisationGuid = sessionStorage.getItem("organisationGuid");
    if (existingOrganisationGuid) {
      this._organisationGuid = existingOrganisationGuid!;
    }

    // get authority:
    let existingAuthority = sessionStorage.getItem("authority");
    if (existingAuthority) {
      this._authority = existingAuthority!;
    }

    // get initial stored columnname
    let showAllRequest = sessionStorage.getItem("ShowAllDocsInOrg");
    if (!showAllRequest || showAllRequest != "true") {
      this._showAllRequestForOrganisation = false;
    } else {
      this._showAllRequestForOrganisation = true;

    }

    // get initial stored columnname
    let columnName = sessionStorage.getItem("SortingColumn");
    if (!columnName) {
      this._sortingColumnName = "lastUpdate"
    } else {
      this._sortingColumnName = columnName!;
    }
    // get initial stored direction
    let direction = sessionStorage.getItem("SortingDirection");
    if (!direction) {
      this._sortDescending = true
    } else {
      this._sortDescending = (direction == this.descendingDirection);
    }
  }

}